<template>
  <div class='full-page-modal rounded-lg'>
    <div class="handlerBar p-8 absolute w-full border-b border-grey-lighter" ref="handlerBar">
      <div v-if="title" class="text-lg font-medium ml-16">
        {{ title }}
      </div>
      <div class="handlerBar__custom flex-auto" v-if="nav">
        <template v-for="link in nav">
          <div v-if="link.action" :key="link.name" @click="link.action" class="btn btn-text btn-grey cursor-pointer">{{ link.name }}</div>
        </template>
      </div>
      <div class="handlerBar__default">
        <button
          class="btn btn-md btn-text border-0 text-grey-darker"
          @click="$emit('close')">
          <!-- {{ $t('close') }} -->
          <i class="owl-status-error" />
        </button>
        <button
          v-if="rightButton"
          class="btn btn-md btn-solid btn-blue px-24"
          @click="rightButton.function">
          {{ rightButton.text }}
        </button>
      </div>
    </div>
    <div class="full-page-modal__content" :style="{ maxHeight: contentHeight, paddingTop: handlerBarHeight + 16 + 'px' }">
      <div :is="context" :data="data" :from="from" @startOrder="startOrder" @openModal="openModal"></div>
      <modal name="bidSuccess" classes="bid-result-modal" :width="345" :height="'auto'" :adaptive="true" :click-to-close="false">
        <img src="@/assets/images/bargain/bid-success.png" alt="">
        <div class="bg-white py-24 text-center" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; margin-top: -4px">
          <div class="text-grey-darkest font-bold text-2xl" style="line-height: 36px">出價成功</div>
          <div class="text-grey-darkest text-sm" style="line-height: 24px">提醒您，放棄付款將無法再參與競標活動</div>
          <div class="btn btn-solid btn-blue-light mt-16 px-16 py-8 text-center no-underline cursor-pointer flex-no-shrink rounded-full border-1 border-blue-light text-base" @click="bidSuccess">
            填寫住宿資料
          </div>
        </div>
      </modal>
      <modal name="bidFailure" classes="bid-result-modal" :width="345" :height="'auto'" :adaptive="true" :click-to-close="false">
        <img src="@/assets/images/bargain/bid-failure.png" alt="">
        <div class="bg-white py-24 text-center" style="border-bottom-left-radius: 20px; border-bottom-right-radius: 20px; margin-top: -4px">
          <div class="text-grey-darkest font-bold text-2xl" style="line-height: 36px">出價失敗</div>
          <div class="text-grey-darkest text-sm" style="line-height: 24px">換個競價數字試試吧</div>
          <div class="btn btn-solid btn-blue-light mt-16 px-16 py-8 text-center no-underline cursor-pointer flex-no-shrink rounded-full border-1 border-blue-light text-base" @click="bidFailure">
            再挑戰一次
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'

export default {
  name: 'fullPageModal',
  data () {
    return {
      isMounted: false,
      isCreatingOrder: false
    }
  },
  props: [
    'nav',
    'context',
    'rightButton',
    'data',
    'from',
    'title'
  ],
  computed: {
    handlerBarHeight: function () {
      if (this.isMounted) {
        return this.$refs.handlerBar.clientHeight
      }
      return 100
    },
    contentHeight: function () {
      // return `calc(100% - ${this.handlerBarHeight}px)`
      return '100%'
    }
  },
  methods: {
    methodHandler: function (btn) {
      if (btn.handler) {
        return btn.handler()
      } else {
        this.$emit('close')
      }
    },
    startOrder: function () {
      this.data.startOrder()
      this.isCreatingOrder = true
    },
    openModal (val) {
      if (val) {
        this.$modal.show('bidSuccess', {
          root: true
        })
      } else {
        this.$modal.show('bidFailure', {
          root: true
        })
      }
    },
    bidSuccess () {
      this.$modal.hide('bidSuccess')
    },
    bidFailure () {
      this.$modal.hide('bidFailure')
    }
  },
  created () {
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang='sass' scoped>
.full-page-modal
  width: 100%
  height: 100%
  overflow-y:  auto
  // max-width: 450px
  .handlerBar
    @apply z-10 bg-white flex justify-between items-center
    &__default
      @apply flex flex-1 justify-end items-center
    // &__custom
  &__cover
    height: 170px
    @apply bg-grey-lightest bg-center bg-no-repeat bg-cover
  &__content
    @apply p-16
    -webkit-overflow-scrolling: touch
    overflow-y: auto
    ul
      @apply pl-24
    &__title
      @apply flex flex-wrap items-center
      &__iconStyle
        @apply mr-4 text-2xl inline-block
        &.success
          @apply text-green
        &.warning
          @apply text-orange
        &.error
          @apply text-red
  .bid-result-modal
    @apply bg-transparent
</style>
<style lang="sass">
.v--modal
  border-radius: 20px !important
</style>
